/**
 * useCanManageManualAssets (AST-114 / AST-115 / AST-116)
 *
 * Mirrors the server's canModifyCustomer (backend/authMiddleware.js): AsseTrac
 * staff (`admins`) for whichever customer is selected in the nav drawer, or a
 * Customer Admin (`customerAdmin-<id>`) for their own customer.
 *
 * This only decides what to SHOW. The server re-checks every request
 * (MOD-40 / LIST-30) -- a user who reaches the route anyway gets 403s and no
 * data, not a working page.
 *
 * Returns { allowed, customer, isStaff }.
 */
import { useAppSelector } from '../store/hooks';

export const canManageManualAssets = (groups, customerId) => {
  if (!customerId) return false;
  const g = groups || [];
  return g.includes('admins') || g.includes(`customerAdmin-${customerId}`);
};

export function useCanManageManualAssets() {
  const groups = useAppSelector((s) => s.auth.userGroups);
  const customer = useAppSelector((s) => s.customer.activeCustomer);
  return {
    allowed: canManageManualAssets(groups, customer?.id),
    customer,
    isStaff: (groups || []).includes('admins'),
  };
}
